import { pageStateType } from 'types';
import { ActionTypes }   from '../actions/types';
  
  
  export const initialPageState: pageStateType = {
    page:      'Root',
    opacity:   1,
    savedPage: 'content'
  }
  
  const pageReducer = (state = initialPageState, action: ActionTypes) => {
  
    switch (action.type) {
  
  
  //SET_LRS_STATE   -      -      -      -      -      -      -      -      -      -      -      -
  
  
  case 'SET_PAGE_STATE':
    {
      return {
          ...state,
          ...action.payload
      }
    }
  
  
  // -      -      -      -      -      -      -      -      -      -      -      -
  
  
  
  
      default: return state;
    }
  };
  
  
  export { pageReducer };
  